import React from "react";
import katex from "katex";
import "katex/dist/katex.min.css";

function renderLatex(text) {
  if (!text) return [];

  // Tokenize: $$...$$ , \[...\] , $...$ , \(...\)
  const tokens = [];
  let remaining = text;

  while (remaining.length > 0) {
    // Display: $$...$$
    const dd = remaining.indexOf("$$");
    // Display: \[...\]
    const dlb = remaining.indexOf("\\[");
    // Inline: $...$
    const si = remaining.indexOf("$");
    // Inline: \(...\)
    const ilp = remaining.indexOf("\\(");

    // Find the earliest match
    const positions = [
      dd >= 0 ? { pos: dd, type: "$$" } : null,
      dlb >= 0 ? { pos: dlb, type: "\\[" } : null,
      si >= 0 && (dd < 0 || si !== dd) ? { pos: si, type: "$" } : null,
      ilp >= 0 ? { pos: ilp, type: "\\(" } : null,
    ].filter(Boolean);

    if (positions.length === 0) {
      tokens.push({ type: "text", content: remaining });
      break;
    }

    positions.sort((a, b) => a.pos - b.pos);
    const first = positions[0];

    // Push text before match
    if (first.pos > 0) {
      tokens.push({ type: "text", content: remaining.slice(0, first.pos) });
    }

    if (first.type === "$$") {
      const end = remaining.indexOf("$$", first.pos + 2);
      if (end < 0) { tokens.push({ type: "text", content: remaining.slice(first.pos) }); break; }
      tokens.push({ type: "display", content: remaining.slice(first.pos + 2, end) });
      remaining = remaining.slice(end + 2);
    } else if (first.type === "\\[") {
      const end = remaining.indexOf("\\]", first.pos + 2);
      if (end < 0) { tokens.push({ type: "text", content: remaining.slice(first.pos) }); break; }
      tokens.push({ type: "display", content: remaining.slice(first.pos + 2, end) });
      remaining = remaining.slice(end + 2);
    } else if (first.type === "$") {
      const end = remaining.indexOf("$", first.pos + 1);
      if (end < 0) { tokens.push({ type: "text", content: remaining.slice(first.pos) }); break; }
      tokens.push({ type: "inline", content: remaining.slice(first.pos + 1, end) });
      remaining = remaining.slice(end + 1);
    } else if (first.type === "\\(") {
      const end = remaining.indexOf("\\)", first.pos + 2);
      if (end < 0) { tokens.push({ type: "text", content: remaining.slice(first.pos) }); break; }
      tokens.push({ type: "inline", content: remaining.slice(first.pos + 2, end) });
      remaining = remaining.slice(end + 2);
    } else {
      tokens.push({ type: "text", content: remaining.slice(first.pos, first.pos + 1) });
      remaining = remaining.slice(first.pos + 1);
    }
  }

  return tokens;
}

export default function LatexRenderer({ text }) {
  if (!text) return null;
  const tokens = renderLatex(String(text));

  return (
    <span>
      {tokens.map((token, i) => {
        if (token.type === "text") return <span key={i}>{token.content}</span>;
        try {
          const html = katex.renderToString(token.content, {
            displayMode: token.type === "display",
            throwOnError: false,
            errorColor: "#c62828",
          });
          return (
            <span
              key={i}
              dangerouslySetInnerHTML={{ __html: html }}
              style={token.type === "display" ? { display: "block", textAlign: "center", margin: "8px 0" } : {}}
            />
          );
        } catch {
          return <span key={i} style={{ color: "#c62828" }}>{token.content}</span>;
        }
      })}
    </span>
  );
}
